<div class="pilot-panel-wall-area">
   <samweb-brick-wall [isPilotPanel]="true"></samweb-brick-wall>
</div>

<button kendoButton (click)="togglePilotPanel()" class="sam-pilot-panel-toggle-button">
   <div class="sam-pilot-panel-toggle-button-content">
      <fa-icon *ngIf="!(isPilotPanelExtended$ | async)" [icon]="arrowLeftIcon"></fa-icon>
      <fa-icon *ngIf="isPilotPanelExtended$ | async" [icon]="arrowRightIcon"></fa-icon>
   </div>
</button>
